{
  "titles": {
    "paymentHistory": "Aflossingen"
  },
  "status": {
    "Scheduled": "Ingepland",
    "Successful": "Gelukt",
    "Failed": "Mislukt",
    "Cancelled": "Geannuleerd",
    "Processing": "Betaling in behandeling"
  },
  "type": {
    "DirectDebit": "Incasso",
    "Transfer": "Overboeking",
    "Renewal": "Afgelost met"
  }
}
